import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TableHeader from '../../common/table/TableHeader';
import SpinTheWheelFilter from './SpinTheWheelFilter';
import { useSearchParams } from 'react-router-dom';
import SpinTheWheelCreateModal from '../../common/Modal/GameConfigModal/SpinTheWheelCreateModal';
import { spinTheWheelConfigsGetAction } from '../../../redux/action/gameConfig';
import SpinTheWheelTable from './SpinTheWheelTable';

const SpinTheWheelContent = () => {
  const [filterValue, setFilterValue] = useState(null);
  const [isFilter, setFilter] = useState(false);

  const [pageCount, setPageCount] = useState(0);
  const [pageSize1, setPageSize] = useState(1);
  const [isModal, setIsModal] = useState(false);

  const dispatch = useDispatch();

  const [searchParam] = useSearchParams();

  const { spinTheWheelConfigs } = useSelector(state => state.gameConfig);
  const onToggleModal = () => {
    setIsModal(!isModal);
  };
  const fetchData = useCallback(
    ({ pageSize, pageIndex }) => {
      dispatch(spinTheWheelConfigsGetAction(filterValue, pageIndex, pageSize));
      setPageSize(pageSize);
    },
    [filterValue]
  );

  const onToggleFilter = () => {
    setFilter(!isFilter);
  };
  useEffect(() => {
    if (spinTheWheelConfigs)
      setPageCount(Math.ceil(spinTheWheelConfigs?.total_items / pageSize1));
  }, [spinTheWheelConfigs, pageSize1]);

  useEffect(() => {
    const filter = Object.fromEntries([...searchParam]);
    setFilterValue(filter);
  }, [searchParam]);
  return (
    <div className="">
      <TableHeader
        FileName={'Spin The Wheel'}
        modalOpenfunc={onToggleModal}
        addButtonEnable={true}
        onToggleFilter={onToggleFilter}
      />
      <div
        className={`absolute w-[23rem] mt-2 p-2 bg-slate-400 rounded-md right-0 z-10 ${
          isFilter ? 'block' : 'hidden'
        }`}
      >
        <SpinTheWheelFilter onToggleFilter={onToggleFilter} />
      </div>
      <SpinTheWheelTable fetchData={fetchData} pageCount={pageCount} />
      {isModal && (
        <SpinTheWheelCreateModal
          isModalOpen={isModal}
          onToggleModal={onToggleModal}
        />
      )}
    </div>
  );
};

export default SpinTheWheelContent;
